// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 30px;\n}\n.img {\n  display: flex;\n  justify-content: center;\n  vertical-align: middle;\n  height: 700px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
